export enum ReservationSource {
  BN_ADMIN = 'admin',
  BN_APP = 'app',
  BN_WEBSITE = 'website',
  CX = 'cx',
  OFFLINE_SALES = 'offline-sales',
  ACQUISITION_TEAM = 'acquisition-team',
  PARTNERS = 'partners',
  CHANNEL_MANAGER = 'channel-manager'
}
